// ================= HEADER JAVASCRIPT MOVED FROM header.liquid =================

// ================= StickyHeader Custom Element =================

class StickyHeader extends HTMLElement {
  constructor() {
    super();
    document.addEventListener('DOMContentLoaded', () => {
      this.reveal();
      this.updateBodyPadding();
    });
    this.calculateHeaderBounds = this.calculateHeaderBounds.bind(this);
  }
  calculateHeaderBounds() {
    if (!this.header) return;
    const headerRect = this.header.getBoundingClientRect();
    this.headerBounds = {
      top: headerRect.top + window.scrollY,
      bottom: headerRect.bottom + window.scrollY,
      height: headerRect.height
    };
    this.enforceFixedPosition();
    this.updateBodyPadding();
  }
  connectedCallback() {
    document.documentElement.style.setProperty('--header-position', 'fixed');
    this.header = this;
    this.headerIsAlwaysSticky = true;
    this.headerBounds = {};
    this.setHeaderHeight();
    const isCollectionPage = document.body.classList.contains('template-collection');
    if (isCollectionPage) {
      document.documentElement.classList.add('is-collection-page');
    }
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    this.classList.add('header-sticky');
    this.style.position = 'fixed';
    this.style.top = '0';
    this.style.left = '0';
    this.style.right = '0';
    this.style.zIndex = '50';
    this.style.width = '100%';
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    document.addEventListener('facet:filter:open', this.onFilterOpen?.bind(this));
    document.addEventListener('facet:filter:close', this.onFilterClose?.bind(this));
    this.createObserver();
    this.setupMutationObserver();
    setTimeout(() => {
      this.calculateHeaderBounds();
      this.checkInitialFilterState?.();
      this.reveal();
      this.updateBodyPadding();
      window.addEventListener('resize', this.enforceFixedPosition.bind(this));
      window.addEventListener('resize', this.updateBodyPadding.bind(this));
    }, 100);
  }
  updateBodyPadding() {
    if (!this.header) return;
    const headerHeight = this.header.offsetHeight || 100;
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    // document.body.style.paddingTop = `${headerHeight}px`; // Commented out to remove body padding
  }
  checkInitialFilterState() {
    const mobileFiltersOpen = document.querySelector('.mobile-facets__details[open]') !== null;
    const mobileFilterActive = document.querySelector('.mobile-facets.active') !== null;
    this.isFilterActive = mobileFiltersOpen || mobileFilterActive;
    if (this.isFilterActive && !this.headerIsAlwaysSticky) {
      this.hide();
    }
  }
  onFilterOpen() {
    this.isFilterActive = true;
    if (!this.headerIsAlwaysSticky) {
      this.hide();
    }
  }
  onFilterClose() {
    this.isFilterActive = false;
    this.reveal();
  }
  setHeaderHeight() {
    const headerHeight = this.header?.offsetHeight || 100;
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
    }
  }
  createObserver() {
    this.calculateHeaderBounds();
    let observer = new IntersectionObserver((entries) => {
      this.calculateHeaderBounds();
      this.enforceFixedPosition();
      this.updateBodyPadding();
    });
    observer.observe(this.header);
    window.addEventListener('resize', this.calculateHeaderBounds);
  }
  hide() {
    if (this.headerIsAlwaysSticky) {
      this.classList.add('header-sticky');
      this.classList.remove('shopify-section-header-hidden');
      this.enforceFixedPosition();
      return;
    }
    this.classList.add('shopify-section-header-hidden', 'header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }
  reveal() {
    this.classList.add('header-sticky', 'animate');
    this.classList.remove('shopify-section-header-hidden');
    document.documentElement.style.setProperty('--header-position', 'fixed');
    this.enforceFixedPosition();
  }
  enforceFixedPosition() {
    if (!this.header) return;
    this.style.position = 'fixed';
    this.style.top = '0';
    this.style.left = '0';
    this.style.right = '0';
    this.style.zIndex = '50';
    this.style.width = '100%';
    this.classList.add('header-sticky');
  }
  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }
  closeSearchModal() {
    this.searchModal = this.searchModal || this.querySelector('details-modal');
    if (this.searchModal) {
      this.searchModal.close(false);
    }
  }
  setupMutationObserver() {
    this.mutationObserver = new MutationObserver((mutations) => {
      let needsRecalculation = false;
      mutations.forEach(mutation => {
        const target = mutation.target;
        const isHeaderRelated = 
          target.classList?.contains('announcement-bar') || 
          target.closest('.announcement-bar') || 
          target.id?.includes('shopify-section-announcement-bar') ||
          target.classList?.contains('shopify-section-group-header-group');
        if (isHeaderRelated && mutation.type === 'childList') {
          needsRecalculation = true;
        }
      });
      if (needsRecalculation) {
        setTimeout(() => {
          this.calculateHeaderBounds();
          this.enforceFixedPosition();
          this.updateBodyPadding();
        }, 50);
      }
    });
    const headersContainer = document.querySelector('.shopify-section-group-header-group');
    if (headersContainer) {
      this.mutationObserver.observe(headersContainer, {
        childList: true,
        subtree: true,
        attributes: true
      });
    }
  }
}

// Register the custom element
customElements.define('sticky-header', StickyHeader);

// === Observe menu drawer open/close to force header dark background ===
document.addEventListener('DOMContentLoaded', () => {
  const stickyHeader = document.querySelector('sticky-header');
  const menuDrawer = document.getElementById('Details-menu-drawer-container');
  const menuOverlay = document.querySelector('.menu-overlay');
  if (!stickyHeader || !menuDrawer || !menuOverlay) return;

  // Track menu drawer open state
  stickyHeader.menuDrawerOpen = menuDrawer.open;

  const mainHeader = stickyHeader.querySelector('.main-header');

  function setHeaderDark(forceDark) {
    stickyHeader.menuDrawerOpen = forceDark;
    if (mainHeader) mainHeader.classList.toggle('menu-open', forceDark);
    if (forceDark) {
      stickyHeader.classList.add('header-dark-background');
      stickyHeader.classList.remove('header-transparent-background');
      menuOverlay.classList.add('active');
    } else {
      // Restore based on scroll position
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      stickyHeader.updateHeaderBackground
        ? stickyHeader.updateHeaderBackground(scrollTop)
        : null;
      menuOverlay.classList.remove('active');
    }
  }

  // Listen for toggle events on the <details> element
  menuDrawer.addEventListener('toggle', () => {
    setHeaderDark(menuDrawer.open);
  });

  // If menu is open on load (edge case), force dark
  if (menuDrawer.open) setHeaderDark(true);

  // Patch updateHeaderBackground to respect menuDrawerOpen
  const origUpdateHeaderBackground = stickyHeader.updateHeaderBackground?.bind(stickyHeader);
  stickyHeader.updateHeaderBackground = function(scrollTop) {
    if (this.menuDrawerOpen) {
      this.classList.add('header-dark-background');
      this.classList.remove('header-transparent-background');
      menuOverlay.classList.add('active');
      if (mainHeader) mainHeader.classList.add('menu-open');
      return;
    }
    menuOverlay.classList.remove('active');
    if (mainHeader) mainHeader.classList.remove('menu-open');
    if (origUpdateHeaderBackground) {
      origUpdateHeaderBackground(scrollTop);
    }
  };

  // === Close menu drawer when clicking outside ===
  document.addEventListener('mousedown', (event) => {
    if (!menuDrawer.open) return;
    // If click is inside the drawer, do nothing
    const drawerPanel = document.getElementById('menu-drawer');
    if (drawerPanel && drawerPanel.contains(event.target)) return;
    // If click is on the hamburger/summary, do nothing
    const summary = menuDrawer.querySelector('summary');
    if (summary && summary.contains(event.target)) return;
    // Otherwise, close the drawer
    menuDrawer.open = false;
  });
}); 